import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges  } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';


import { WorkflowsService } from '@app/services/settings/workflows.service';


import { Workflow } from '@core/objects/workflow';

@Component({
    selector: 'settings-workflows-edit-name-form',
    templateUrl: './edit-name-form.component.html',
    styleUrls: ['./edit-name-form.component.scss']
})
export class SettingsWorkflowsEditNameFormComponent implements OnInit, OnChanges{

	public readonly STATUS_INITIAL = 0;
	public readonly STATUS_LOADING = 1;
	public readonly STATUS_DONE = 2;
	public readonly STATUS_ERROR = 3;
	public readonly STATUS_NOT_ALLOWED = 4;

    @Input() workflow: Workflow
    @Output() actionCancel = new EventEmitter<any>();
    @Output() actionSubmit = new EventEmitter<any>();

    public actionStatus: Number = this.STATUS_INITIAL;

    public form: FormGroup;
    public showInstructions: boolean =  false;

	constructor(public workflowsSrv: WorkflowsService, private formBuilder: FormBuilder){}

	ngOnInit(){
        if(this.workflow == null)
            return
		this.init();

	}

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.workflow && changes.workflow.currentValue != null){
            this.init();
        }
    }

    init(){
        this.form = this.formBuilder.group({
            name: [this.workflow.name, [Validators.required]]
		});
        this.actionStatus = this.STATUS_INITIAL;
    }

	onCancel(event) {
        // console.log(" cancel triggered")
        this.actionCancel.emit(event);
        this.init();
	}

    // action when push modal buton when error
    onError(event) {
        this.init();
        this.actionCancel.emit(event);
    }

    updateName(){
        if(this.form.invalid)
			return;

        this.actionStatus = this.STATUS_LOADING;
        this.workflowsSrv.updateWorkflowName$(this.form.value.name,this.workflow.id).subscribe({
            next: (empty: any) => {
                this.cleanForm();
                this.actionSubmit.emit();
                this.actionStatus = this.STATUS_DONE;
            },
            error: (err) => {
                console.debug(" name update: errroorrrr ",err);
                this.actionStatus = this.STATUS_ERROR;
            }
        });

    }

    cleanForm(){
		this.form.reset({name: ''});
	}

}
